const formatter = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' })

export function formatPrice(amount: number): string {
  return formatter.format(amount)
}
